export default __webpack_public_path__ + "static/testimonial-3-bb9f49c1ae326441f5e27bed4d4780c9.jpg";